<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'onboarding.customIcon.title' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="cancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form" class="custom-icon-form" (ngSubmit)="onSubmit()">
      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{ 'onboarding.customIcon.iconImage' | translate }}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <app-image-uploader
            [wrongTypeMessage]="'onboarding.customIcon.wrongTypeMessage' | translate"
            [description]="'onboarding.customIcon.description' | translate"
            [additionalDescription]="'onboarding.customIcon.additionalDescription' | translate"
            [previewImageStyles]="imageService.getImageStyle(form.get('imageWidth').value)"
            (onFileChange)="fileChange($event)"
            (onFileRemove)="removeFile()"
          ></app-image-uploader>
          <input matInput formControlName="file" hidden="true" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['file'])">{{ 'onboarding.customIcon.iconImageRequired' | translate }}</mat-error>
        </mat-form-field>
      </div>

      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{ 'onboarding.customIcon.iconName' | translate }}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="name" type="text" [placeholder]="'onboarding.customIcon.enterIconName' | translate" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['name'])">{{ 'onboarding.customIcon.iconNameRequired' | translate }}</mat-error>
        </mat-form-field>
      </div>

      <div class="app-dialog__field">
        <label class="app-dialog__field-label">{{ 'onboarding.customIcon.url' | translate }}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput formControlName="url" type="url" [placeholder]="'onboarding.customIcon.enterUrl' | translate" [errorStateMatcher]="errorStateMatcher">
          <mat-error *ngIf="form.hasError('required', ['url'])">{{ 'onboarding.customIcon.urlRequired' | translate }}</mat-error>
        </mat-form-field>
      </div>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="cancel()">{{ 'onboarding.customIcon.cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="onSubmit()">{{ 'onboarding.customIcon.addIcon' | translate }}</button>
  </footer>
</div>
